"use strict";

exports.__esModule = true;

function hslToString(_a) {
  var h = _a[0],
      s = _a[1],
      l = _a[2];
  return "hsl(" + h + "," + s + "," + l + ")";
}

exports.hslToString = hslToString;

function rgbToString(_a) {
  var r = _a[0],
      g = _a[1],
      b = _a[2];
  return "rgb(" + r + "," + g + "," + b + ")";
}

exports.rgbToString = rgbToString;